import { useTheme } from 'styled-components'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import RichTextEditor from '@/common/components/RichTextEditor/RichTextEditor'
import { copyInputTypes } from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/constants'
import InputWithTextarea from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/InputWithTextarea/InputWithTextarea'

const CopyInput = ({
  copy,
  selectedCopyLanguage,
  customCopies,
  onChangeCopy,
  onChangeTextarea,
  merchantInfo,
  onPreviewChange,
  onLanguageChange,
}) => {
  const theme = useTheme()
  const value = customCopies[selectedCopyLanguage]?.[copy.key]

  const handleFocus = () => {
    onPreviewChange?.(copy?.key)
    onLanguageChange?.(selectedCopyLanguage)
  }

  if (copy.copyType === copyInputTypes.text) {
    return (
      <InputWithLabel
        placeholder={copy?.placeholder(selectedCopyLanguage)}
        value={value || ''}
        onChange={e => onChangeCopy(e.target.value, copy.key, selectedCopyLanguage)}
        onFocus={handleFocus}
        maxLength={50}
        fullWidth
        backgroundColor={theme.colors.background.primary}
      />
    )
  }

  if (copy.copyType === copyInputTypes.richText) {
    return (
      <RichTextEditor
        key={`${copy.key}-${selectedCopyLanguage}`}
        placeholder={copy?.textareaPlaceholder?.(selectedCopyLanguage)}
        value={value?.message || ''}
        onChange={result => onChangeCopy(result.html, copy.key, selectedCopyLanguage, 'message')}
        maxHeight="150px"
      />
    )
  }

  if (copy.copyType === copyInputTypes.titleAndTextArea) {
    return (
      <InputWithTextarea
        key={`${copy.key}-${selectedCopyLanguage}`}
        inputPlaceholder={copy?.placeholder?.(selectedCopyLanguage)}
        inputValue={value?.title || ''}
        onChangeInput={inputValue => onChangeCopy(inputValue, copy?.key, selectedCopyLanguage, 'title')}
        textareaPlaceholder={copy?.textareaPlaceholder?.(selectedCopyLanguage, merchantInfo)}
        textareaValue={value?.message || ''}
        onChangeTextarea={onChangeTextarea}
        hideInput={copy?.hideInput}
        onFocus={handleFocus}
        useHtmlInTextArea={copy?.useHtmlInTextArea}
      />
    )
  }

  return null
}

export default CopyInput
